import gql from 'graphql-tag';

export const GET_PAGE_BY_URL = gql`
  query PageByUrl($url: [String]) {
    getPageByUrl(input: { url: $url }) {
      created_at
      tenant {
        id
        name
        connection
        gtm_id
        logo_url
        custom_css
        partner_type_id
      }
      blocks {
        ... on VideoListBlock {
          type
          heading
          background
          orientation
          ranking
          items {
            ranking
            video {
              id
              title
              url
              preview_url
              duration
              description
              verse_video_id
              difficulty {
                id
                title
                icon_url
              }
              user {
                id
                name
              }
              categories {
                title
              }
            }
          }
        }
        ... on PathwayListBlock {
          type
          heading
          ranking
          with_categories
          items {
            ranking
            pathway {
              id
              name
              image_url
              videos {
                id
                duration
              }
              duration
              count_videos
              categories {
                id
                title
                parent {
                  id
                  title
                }
              }
            }
          }
        }
        ... on NewsBlock {
          type
          ranking
          heading
          news_limit
          background
          button_url
          button_text
        }
        ... on ImageArrayBlock {
          type
          ranking
          heading
          desktop_image
          items {
            image
            heading
            description
          }
          button_url
          button_text
          background
          type_image
        }
        ... on ImagesAndTextArrayBlock {
          type
          ranking
          heading
          background
          items {
            ... on TextContent {
              type
              ranking
              text
            }
            ... on ImageContent {
              type
              ranking
              title
              alt
              image
            }
          }
        }
        ... on PartnersBlock {
          type
          ranking
          heading
          #          description
          white_icon
          partnerType {
            id
          }
          background
          display
        }
        ... on IntroVideoBlock {
          type
          heading
          video_url
          preview_video_url
          preview_image_url
          button_text
          button_url
          gradient
          background
          description
          ranking
          heading_highlight_color
          watch_video_button_text
          usp_blocks {
            image
            seo_image_name
            label_text
          }
        }
        ... on IntroImageBlock {
          type
          heading
          preview_image_url
          button_text
          button_url
          description
          gradient
          ranking
          usp_blocks {
            image
            seo_image_name
            label_text
          }
        }
        ... on CatalogueOfCategoriesBlock {
          ranking
          heading
          type
          background
        }
        ... on ContactDetailsBlock {
          type
          heading
          background
          ranking
          items {
            heading
            icon_url
            editable_html
          }
        }
        ... on ContactFormBlock {
          type
          heading
          background
          ranking
        }
        ... on ExpertsListBlock {
          type
          heading
          description
          background
          ranking
          items {
            expert {
              id
              avatar
              name
              job_title
              slug
            }
          }
        }
        ... on SeoBlock {
          type
          seo_title
          seo_description
          share_image
        }
        ... on PricingBlock {
          type
          heading
          background
          button_text
          button_url
        }

        ... on HTMLBlock {
          type
          html_code
        }

        ... on JSBlock {
          type
          js_code
        }

        ... on QuotesListBlock {
          type
          background
          background_image
          quotes {
            title
            sub_title
            color_text
            cta_button_link
            cta_button_text
          }
        }

        ... on CTABlock {
          type
          background
          title
          link
        }

        ... on ForEnterprise {
          type
          ranking
          background
          heading
          sub_title
          description
          button_text
          button_url
          content {
            title
            desktopImageUrl
            mobileImageUrl
          }
        }

        ... on AllProfessionals {
          type
          ranking
          background
          heading
          image
          content {
            title
            sub_title
            image
            link
          }
        }

        ... on TrustpilotBlock {
          type
          background
          title
          description
          trustpilot_image
        }
      }
    }
  }
`;
